// This is an auto-generated file. Do not edit.
export const VERSION = '@civic/solana-gateway-react:0.16.13';
